import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as moment from 'moment';
import { Observable, Subject, Subscription } from 'rxjs';
import { map, pluck, shareReplay, tap } from 'rxjs/operators';
import { AltriSoggettiGiudiziarioDTO } from '../../models/altri-soggetti-giudiziario-dto';
import { AltriSoggettiNoEsproprioDTO } from '../../models/altri-soggetti-no-esproprio-dto';
import { InfoAnagrafichePFDTO } from '../../models/info-anagrafiche-pf';
import { InfoNascitaPFDTO } from '../../models/info-nascita-pf.dto';
import { PersonaFisicaDTO } from '../../models/persona-fisica-dto';
import { PersonaGiuridicaDTO } from '../../models/persona-giuridica-dto';
import { DatiPersonaFisica } from '../../models/portale/dati-persona-fisica';
import { PersonaFisica } from '../../models/portale/persona-fisica-model';
import { PersonaGiuridica } from '../../models/portale/persona-giuridica-model';
import { TipologicaDTO } from '../../models/tipologica-d-t-o';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { DelegheService } from '../../services/deleghe-services/deleghe.service';
import { MessageService } from '../../services/message.service';
import { ComponentReducer } from '../../utils/component-reducer';
import { Modals } from '../../utils/modals';
import { Localita } from '../../models/portale/localita';
import { Nazione } from '../../models/portale/nazione';
@Component({
	selector: 'lib-altri-soggetti',
	templateUrl: './altri-soggetti.component.html',
	styleUrls: ['./altri-soggetti.component.css']
})
export class AltriSoggettiComponent implements OnInit, OnDestroy {

	form: FormGroup;

	@Input()
	altriSoggetti: AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO;

	@Input()
	tipologieSoggetto$: Observable<Array<TipologicaDTO>>;

	@Input()
	cfDifferentFrom: string;

	@Input()
	namespace: string;

	@Input()
	formControlSoggetto: boolean;

	@Input()
	province: Observable<Array<Localita>>;

	@Input()
	nazioni: Observable<Array<Nazione>>;

	@Output()
	nextStep: EventEmitter<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>
		= new EventEmitter<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>();

	@Output()
	salvaBozza: EventEmitter<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>
		= new EventEmitter<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>();

	@Output()
	previousStep: EventEmitter<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>
		= new EventEmitter<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>();

	//TODO
	// changesPF$ = new Subject<
	// 	ComponentOutputStatus<(value: AltriSoggettiGiudiziarioDTO) => void>
	// >();

	//TODO
	// changesPF2$ = new Subject<
	// 	ComponentOutputStatus<(value: AltriSoggettiNoEsproprioDTO) => void>
	// >();

	changesRicercaPG$ = new Subject<
		ComponentOutputStatus<(value: AltriSoggettiNoEsproprioDTO) => void>
	>();

	changesRicercaPF$ = new Subject<
		ComponentOutputStatus<(value: AltriSoggettiNoEsproprioDTO) => void>
	>();

	changesPersonaGiuridica$ = new Subject<
		ComponentOutputStatus<(value: AltriSoggettiNoEsproprioDTO) => void>
	>();

	changesPersonaFisica$ = new Subject<
		ComponentOutputStatus<(value: AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO) => void>
	>();

	namespaceInfoPf: string;

	altriSoggettiChangedSub: Subscription;

	tipoSoggetto: FormControl;
	soggettoNonIdentificato: FormControl;

	checkSoggetto$: Observable<Boolean>;

	tipoSoggetto$: Observable<string>;

	direction: string = "both-ways";
	isFinal: boolean = false;
	isFormValid: boolean;

	showComponentRicercaPF: boolean = false;
	showComponentRicercaPG: boolean = false;
	isSearching: boolean = false;

	// personaGiuridica: PersonaGiuridica;
	personaGiuridica: any;
	personaGiuridica$: Observable<PersonaGiuridica>;
	// personaFisica: DatiPersonaFisica;
	personaFisica: PersonaFisicaDTO;
	personaFisica$: Observable<PersonaFisica>;

	pfSubscription: Subscription;

	pgSubscription: Subscription;
	nspg: string;

	constructor(
		private delegheService: DelegheService,
		private modals: Modals,
		private msg: MessageService
	) { }

	ngOnInit() {

		//console.log('[AltriSoggettiGiudiziarioDTO - AltriSoggettiNoEsproprioDTO]', this.altriSoggetti);

		this.form = new FormGroup({});
		let valid: boolean = true;

		this.nspg = "nsRapprLegpg";

		if (!this.altriSoggetti) {
			this.initAltriSoggetti();
			valid = false;
		} else {
			if (this.formControlSoggetto) {
				this.personaGiuridica = (<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).personaGiuridica;
				if (this.personaGiuridica) {
					this.showComponentRicercaPG = true;
				}

				this.personaFisica = (<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).personaFisica;
				if (this.personaFisica) {
					this.showComponentRicercaPF = true;
				}

				if ((<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto === 'SOGGETTO_DA_IDENTIFICARE') {
					(<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceRegione = '';
				}
				} else {
					if (!((<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).soggettoNonIdentificato)) {
						this.personaFisica = this.mapperPersonaFisica(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti);
					}
			}
		}

		this.tipoSoggetto = new FormControl(
			{ value: (<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto, disabled: false },
			[Validators.required]);
		this.form.addControl('tipoSoggetto', this.tipoSoggetto);

		this.soggettoNonIdentificato = new FormControl(
			{ value: (<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).soggettoNonIdentificato, disabled: false });
		this.form.addControl('soggettoNonIdentificato', this.soggettoNonIdentificato);

		this.namespaceInfoPf = this.namespace + "infoPF";

		if (!this.formControlSoggetto) {
			if ((<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).soggettoNonIdentificato) {
				this.showComponentRicercaPF = false;
			} else {
				this.showComponentRicercaPF = true;
			}
		}

		this.checkSoggetto$ = this.soggettoNonIdentificato.valueChanges.pipe(
			// tap(checkSoggetto => console.log('[checkSoggetto$] - soggettoNonIdentificato:', checkSoggetto)),
			tap((checkSoggetto) => {
				if (!checkSoggetto) {
					this.showComponentRicercaPF = true;
					this.isSearching = false;
				} else {
					this.resetSoggetti();
					this.showComponentRicercaPF = false;
					this.isSearching = false;
				}
			}),
			shareReplay());

		const changesCheckSoggetto$: Observable<ComponentOutputStatus<
			(value: AltriSoggettiGiudiziarioDTO) => void
		>> = this.checkSoggetto$.pipe(
			// tap(checkSoggetto => console.log('[changesCheckSoggetto$] - soggettoNonIdentificato:', checkSoggetto)),
			map((checkSoggetto) => {
				this.changesPersonaFisica$.next(
					ComponentOutputStatus.of(true, (personaFisica) => (sogg: AltriSoggettiGiudiziarioDTO) => {}));
				return ComponentOutputStatus.of(true,
					(soggetto: AltriSoggettiGiudiziarioDTO) => (soggetto.soggettoNonIdentificato = checkSoggetto)
				);
			})
		);

		this.tipoSoggetto$ = this.tipoSoggetto.valueChanges.pipe(
			// tap(tipo => console.log('[tipoSoggetto$] - codiceSoggetto:', tipo)),
			tap((tipo) => {
				if (tipo != 'SOGGETTO_DA_IDENTIFICARE') {
					this.setSoggetto(tipo);
					this.isSearching = false;
				} else {
					this.resetSoggetti();
					this.showComponentRicercaPF = false;
					this.showComponentRicercaPG = false;
					this.isSearching = false;
					this.resetValidation();
				}
			}),
			shareReplay()
		);

		const tipoSoggettoChanges$: Observable<ComponentOutputStatus<
			(value: AltriSoggettiNoEsproprioDTO) => void
		>> = this.tipoSoggetto$.pipe(
			// tap(tipoSoggettoChanges => console.log('[tipoSoggettoChanges$] - codiceTipoAltroSoggetto:', tipoSoggettoChanges)),
			map((tipo) => {
				return ComponentOutputStatus.of(
					this.tipoSoggetto.valid,
					(sog: AltriSoggettiNoEsproprioDTO) => (sog.codiceTipoAltroSoggetto = tipo)
				);
			})
		);

		const altriSoggetti$ = ComponentReducer.reducer4(
			tipoSoggettoChanges$,
			changesCheckSoggetto$,
			// TODO
			// this.changesRicercaPF$,
			this.changesPersonaFisica$,
			// this.changesRicercaPG$,
			// TODO
			this.changesPersonaGiuridica$,
			(soggetto) => {
				let isValid: boolean;
				// console.log('[codiceTipoAltroSoggetto]', (<AltriSoggettiNoEsproprioDTO>soggetto).codiceTipoAltroSoggetto);
				// console.log('[soggettoNonIdentificato]', (<AltriSoggettiGiudiziarioDTO>soggetto).soggettoNonIdentificato);
				if (this.formControlSoggetto) {
					switch ((<AltriSoggettiNoEsproprioDTO>soggetto).codiceTipoAltroSoggetto) {
						case 'PRESUNTO_BENEFICIARIO':
							// isValid = (<AltriSoggettiNoEsproprioDTO>soggetto).idPersona != null && this.tipoSoggetto.value;
							isValid = soggetto.idPersona != null && this.tipoSoggetto.value;
							break;
						case 'AUTORITA_ORDINANTE':
							// isValid = (<AltriSoggettiNoEsproprioDTO>soggetto).idPersona != null && this.tipoSoggetto.value;
							isValid = soggetto.idPersona != null && this.tipoSoggetto.value;
							break;
						default:
							isValid = true;
					}
				} else {
					(<AltriSoggettiGiudiziarioDTO>soggetto).soggettoNonIdentificato ?
						// isValid = true : isValid = (<AltriSoggettiGiudiziarioDTO>soggetto).idPersona != null
						isValid = true : isValid = soggetto.idPersona != null;
				}
				// console.log('[idPersona]', (<AltriSoggettiNoEsproprioDTO>soggetto).idPersona)
				// console.log('[idPersona]', (<AltriSoggettiGiudiziarioDTO>soggetto).idPersona)
				return isValid;
			},
			ComponentOutputStatus.of(valid, this.altriSoggetti)
		)

		altriSoggetti$.subscribe((soggetto: ComponentOutputStatus<AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO>) => {
			// console.log('[AltriSoggettiComponent] altriSoggetti', soggetto);
			this.altriSoggetti = soggetto.output;
			this.altriSoggetti.idPersona = soggetto.output.idPersona;
			this.isFormValid = soggetto.status;
		});
	}

	resetValidation() {
		this.changesPersonaFisica$.next(
			ComponentOutputStatus.of(true, (personaFisica) => (sogg: AltriSoggettiNoEsproprioDTO) => { })
		);

		this.changesPersonaGiuridica$.next(
			ComponentOutputStatus.of(true, (personaGiuridica) => (sogg: AltriSoggettiNoEsproprioDTO) => { })
		)
	}

	initAltriSoggetti() {
		if (this.formControlSoggetto) {
			this.altriSoggetti = new AltriSoggettiNoEsproprioDTO();
		} else {
			this.altriSoggetti = new AltriSoggettiGiudiziarioDTO();
		}
	}

	// TODO
	public viewPersona(): boolean {
		if (this.formControlSoggetto) {
			return !this.tipoSoggetto.value ||
				this.tipoSoggetto.value === "SOGGETTO_DA_IDENTIFICARE"
		}
		else {
			let showComponent: boolean;
			this.checkSoggetto$.subscribe(_ => {
				// console.log('[checkSoggetto]', _);
				showComponent = _.valueOf();
			});
			return showComponent;
		}
	}

	setSoggetto(tipo: string) {
		// console.log('[setDelega]', delega);
		// console.log('[isPersonaFisica]', this.isPersonaFisica(this.rappresentanza.codiceDelega))
		// console.log('[isPersonaGiuridica]', this.isPersonaGiuridica(this.rappresentanza.codiceDelega))
		// console.log('[codiceDelega]', this.rappresentanza.codiceDelega);

		this.resetSoggetti();

		if (this.isPersonaFisica(tipo)) {
			this.showComponentRicercaPF = true;
			this.showComponentRicercaPG = false;
		}

		if (this.isPersonaGiuridica(tipo)) {
			this.showComponentRicercaPF = false;
			this.showComponentRicercaPG = true;
		}
	}

	resetSoggetti() {

		if (!this.altriSoggetti) {
			this.initAltriSoggetti();
		}

		if (this.formControlSoggetto) {
			(<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).personaGiuridica = null;
			this.personaGiuridica = null;
			(<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceRegione = '';
		} else {
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).soggettoNonIdentificato = this.soggettoNonIdentificato.value;
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).cognome = null;
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).nome = null;
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).codFiscale = null;
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).comuneNascita = null;
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).provinciaNascita = null;
			(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).dataNascita = null;
		}
		this.altriSoggetti.idPersona = null;
		this.altriSoggetti.personaFisica = null;
		this.personaFisica = null;
	}

	isPersonaFisica(codiceSoggetto: string): boolean {
		return (codiceSoggetto === "PRESUNTO_BENEFICIARIO")
	}

	isPersonaGiuridica(codiceSoggetto: string): boolean {
		return (codiceSoggetto === 'AUTORITA_ORDINANTE')
	}

	ricercaPFReady(ricercaPFStatus: ComponentOutputStatus<DatiPersonaFisica>) {
		// console.log('[ricercaPFReady]', ricercaPFStatus);
		this.changesRicercaPF$.next(
			ricercaPFStatus.mapValue(
				(infoPF) => (sogg: AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO) => {
					this.getPersonaFisica(infoPF.id);
					if (!this.formControlSoggetto) {
						(<AltriSoggettiGiudiziarioDTO>sogg).soggettoNonIdentificato = false;
					}
					sogg.idPersona = infoPF.id;
				})
		);
	}

	personaFisicaReady(personaFisicaStatus: ComponentOutputStatus<PersonaFisicaDTO>) {
		//console.log('[personaFisicaReady]', personaFisicaStatus);
		this.changesPersonaFisica$.next(
			personaFisicaStatus.mapValue(
				(personaFisica) => (sogg: AltriSoggettiNoEsproprioDTO | AltriSoggettiGiudiziarioDTO) => {
					const pf = new PersonaFisicaDTO();
					pf.infoAnagrafiche = personaFisica.infoAnagrafiche;
					pf.infoNascita = personaFisica.infoNascita;
					pf.id = personaFisica.id;
					if(personaFisica.id){
						sogg.idPersona = personaFisica.id;
					}
					sogg.personaFisica = pf;
					if (!this.formControlSoggetto) {
						this.soggettoNonIdentificato.value ?
							(<AltriSoggettiGiudiziarioDTO>sogg).soggettoNonIdentificato = this.soggettoNonIdentificato.value :
								(<AltriSoggettiGiudiziarioDTO>sogg).soggettoNonIdentificato = false;

						(<AltriSoggettiGiudiziarioDTO>sogg).cognome = personaFisica?.infoAnagrafiche?.cognome;
						(<AltriSoggettiGiudiziarioDTO>sogg).nome = personaFisica?.infoAnagrafiche?.nome;
						(<AltriSoggettiGiudiziarioDTO>sogg).codFiscale = personaFisica?.infoAnagrafiche?.codFiscale;
						(<AltriSoggettiGiudiziarioDTO>sogg).comuneNascita = personaFisica?.infoNascita?.comuneNascita;
						(<AltriSoggettiGiudiziarioDTO>sogg).provinciaNascita = personaFisica?.infoNascita?.provinciaNascita;
						//TODO
						// (<AltriSoggettiGiudiziarioDTO>sogg).dataNascita = new Date(moment(personaFisica?.infoNascita?.dataNascita, "DD/MM/YYYY").toDate());
						// (<AltriSoggettiGiudiziarioDTO>sogg).dataNascita = moment(personaFisica?.infoNascita?.dataNascita, "DD/MM/YYYY").toDate();
						(<AltriSoggettiGiudiziarioDTO>sogg).dataNascita = personaFisica?.infoNascita?.dataNascita;
					}
				}
			)
		);
	}

	ricercaPGReady(ricercaPGStatus: ComponentOutputStatus<PersonaGiuridica>) {
		// console.log('[ricercaPGReady]', ricercaPGStatus);
		this.changesRicercaPG$.next(
			ricercaPGStatus.mapValue(
				(infoPG) => (sogg: AltriSoggettiNoEsproprioDTO) => {
					this.getPersonaGiuridica(infoPG.datiPersonaGiuridica.id);
					sogg.idPersona = infoPG.datiPersonaGiuridica.id;
				})
		);
	}

	personaGiuridicaReady(personaGiuridicaStatus: ComponentOutputStatus<PersonaGiuridicaDTO>) {
		// console.log("[personaGiuridicaReady]", personaGiuridicaStatus);
		this.changesPersonaGiuridica$.next(
			personaGiuridicaStatus.mapValue(
				(personaGiuridica) => (sogg: AltriSoggettiNoEsproprioDTO) => {
					const pg = new PersonaGiuridicaDTO();
					pg.codiceFiscale = personaGiuridica.codiceFiscale;
					pg.ragioneSociale = personaGiuridica.ragioneSociale;
					pg.partitaIVA = personaGiuridica.partitaIVA;
					pg.idPersonaGiuridica = personaGiuridica.idPersonaGiuridica;
					sogg.idPersona = personaGiuridica.idPersonaGiuridica;
					sogg.personaGiuridica = pg;
					if (personaGiuridica.sedi != undefined) {
						sogg.codiceRegione = personaGiuridica?.sedi[0]?.indirizzo?.regione?.sigla;
					}
				}
			)
		);
	}

	getPersonaFisica(id: string) {
		this.showComponentRicercaPF = false;
		//debugger
		this.personaFisica$ = this.delegheService.getPersona(id)
			.pipe(shareReplay());

		this.pfSubscription = this.personaFisica$.pipe(
			// pluck("datiPersonaFisica")
		).subscribe(
			// (pf: DatiPersonaFisica) => {
			(pf) => {
				//console.log('[pf]', pf);
				this.personaFisica = this.mapperPersonaFisica(pf.datiPersonaFisica);
				// this.personaFisica = pf;
				(<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceRegione = pf?.residenza?.regione?.sigla;
				//(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).personaFisica = this.personaFisica;
				this.altriSoggetti.idPersona = id;
				// this.showComponentRicercaPF = true;
				if (this.personaFisica) {
					setTimeout(() => this.showComponentRicercaPF = true, 0);
				}
				this.isSearching = true;
			},
			_ => {
				this.modals.failure([
					"recupero.datipersonafisica.failure"
				], []);
			}
		);
	}

	getPersonaGiuridica(id: string) {
		this.personaGiuridica$ = this.delegheService.getDatiSocieta(id)
			.pipe(shareReplay());

		this.pgSubscription = this.personaGiuridica$.pipe(
			// pluck("datiPersonaGiuridica")
		).subscribe(
			(pg: PersonaGiuridica) => {
				// console.log('[pg]', pg);
				this.mapperPersonaGiuridica(pg);
				this.personaGiuridica = pg;
				// (<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).idPersona = id;
				this.altriSoggetti.idPersona = id;
				this.showComponentRicercaPG = false;
				this.isSearching = true;
				if (pg.sedi != undefined) {
					const sede = pg.sedi.filter(sedeLegale => sedeLegale.tipoSede.codice === "LEGALE");
					(<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceRegione = sede[0].indirizzo.regione.sigla;
				}
			},
			_ => {
				this.modals.failure([
					"recupero.datipersonagiuridica.failure"
				], []);
			}
		);
	}

	mapperPersonaFisica(datiPersona): PersonaFisicaDTO {
		//console.log('[mapperPersonaFisica]- datiPersona', datiPersona);

		const personaFisica = new PersonaFisicaDTO();
		const infoAnagrafiche = new InfoAnagrafichePFDTO();
		infoAnagrafiche.codFiscale = datiPersona.codFiscale;
		infoAnagrafiche.cognome = datiPersona.cognome;
		infoAnagrafiche.nome = datiPersona.nome;
		personaFisica.infoAnagrafiche = infoAnagrafiche;
		personaFisica.id = datiPersona.idPersona;
		const infoNascita = new InfoNascitaPFDTO();
		infoNascita.comuneNascita = datiPersona.comuneNascita;
		infoNascita.provinciaNascita = datiPersona.provinciaNascita;
		infoNascita.dataNascita = datiPersona.dataNascita;
		personaFisica.infoNascita = infoNascita;
		(<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).personaFisica = personaFisica;
		//console.log('[mapperPersonaFisica]- personaFisica', personaFisica);
		//console.log('[mapperPersonaFisica]- altriSoggetti', this.altriSoggetti.personaFisica);
		setTimeout(() => this.showComponentRicercaPF = true, 0);
		return personaFisica;
	}

	mapperPersonaGiuridica(datiPersona: PersonaGiuridica) {
		// console.log('[mapperPersonaGiuridica]', datiPersona);

		if (!this.altriSoggetti) {
			this.initAltriSoggetti();
		}

		const personaGiuridica = new PersonaGiuridicaDTO();
		personaGiuridica.codiceFiscale = datiPersona.datiPersonaGiuridica.codiceFiscale;
		personaGiuridica.ragioneSociale = datiPersona.datiPersonaGiuridica.ragioneSociale;
		personaGiuridica.partitaIVA = datiPersona.datiPersonaGiuridica.partitaIVA;
		(<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).personaGiuridica = personaGiuridica;
	}

	enableSearch() {
		this.resetSoggetti();

		// console.log('[enableSearch] - codiceSoggetto:', (<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto);
		// console.log('[enableSearch] - soggettoNonIdentificato:', (<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).soggettoNonIdentificato);

		if ((<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto) {

			this.tipoSoggetto.setValue((<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto);

			if (this.isPersonaFisica((<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto)) {
				setTimeout(() => this.showComponentRicercaPF = true, 0);
			}

			if (this.isPersonaGiuridica((<AltriSoggettiNoEsproprioDTO>this.altriSoggetti).codiceTipoAltroSoggetto)) {
				setTimeout(() => this.showComponentRicercaPG = true, 0);
			}
		} else {
			this.soggettoNonIdentificato.setValue((<AltriSoggettiGiudiziarioDTO>this.altriSoggetti).soggettoNonIdentificato);
			setTimeout(() => this.showComponentRicercaPF = true, 0);
		}
	}

	forward(_: any) {
		this.nextStep.emit(this.altriSoggetti);
	}

	backward($event: any) {
		this.previousStep.emit(this.altriSoggetti);
	}

	complete($event: any) { }

	onSalvaBozza($event: any) {
		this.salvaBozza.emit(this.altriSoggetti);
	}

	ngOnDestroy(): void {
		if (this.altriSoggettiChangedSub) {
			this.altriSoggettiChangedSub.unsubscribe();
		}
	}
}
